/// <reference path="../../_ext/Bases/TransDialog.ts" />

namespace TabAurous.Inventory {
    import fld = StockAllocationItemsRow.Fields;
    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class StockAllocationDialog extends _Ext.TransDialog<StockAllocationRow, any> {

        protected getFormKey() { return StockAllocationForm.formKey; }
        protected getIdProperty() { return StockAllocationRow.idProperty; }
        protected getLocalTextPrefix() { return StockAllocationRow.localTextPrefix; }
        protected getNameProperty() { return StockAllocationRow.nameProperty; }
        protected getService() { return StockAllocationService.baseUrl; }
        protected getDeletePermission() { return StockAllocationRow.deletePermission; }
        protected getInsertPermission() { return StockAllocationRow.insertPermission; }
        protected getUpdatePermission() { return StockAllocationRow.updatePermission; }
        protected useViewMode() { return true; }
        public isReadOnly = this.isViewMode();       
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        public form = new StockAllocationForm(this.idPrefix);

        // #region Variables
        TaxRegistred: number;
        TaxArray: any[];
        public Closing: boolean = true;
        static image: string;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public CurrencyId: number;

        // #endregion
        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initItemEditor(this, this.form.ItemDetails, Config);
            // #region UI
            //Make grid full width
            q.hideEditorLabel(this.form.ItemDetails);   
            q.setGridEditorHeight(this.form.ItemDetails, 290);  
            q.SetCategorySixColumn(this.form.TransDate);  
            q.SetCategoryFullWidth(this.form.ItemDetails);  
            q.SetCategoryFullWidth(this.form.Remark);
            q.HideCategoryLable(this.element); 
            this.form.ItemDetails.slickGrid.setOptions({ forceFitColumns: true }); 
            this.CurrencyId = Q.Authorization.userDefinition.CurrencyId; 

     
            
        }
 
        protected onDialogOpen() {
            super.onDialogOpen();
        }

        
        // **** Get Set Toolbar Buttons **** 
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();
            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");
            var oldDeleteClick = btnDelete.onClick;
            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };

            //Edit Click Override
            var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            var oldEditClick = btnEdit.onClick;
            btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };
            var postingpermission = Q.Authorization.hasPermission('Inventory:StockAllocation:Posting');
            //Export PDF Button
            btns.push({
                title: 'Post',
                icon: 'las la-check-double',
                cssClass: 'approve-doc-button',
                onClick: () => {
                    var entity = this.entity;
                    entity.AutoPosting = true; delete entity.TransDate;
                 
                   StockAllocationService.Update({ Entity: entity, EntityId: entity.TransId }, response => {
                        if (response.Error == null) {
                            this.dialogClose();
                            Serenity.SubDialogHelper.triggerDataChange(this);
                        }
                    }, { async: false })
                },
                visible: postingpermission

            });


            return btns;
        }

        // #region Edit Delete Validation
        // **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        private confirmBeforeEdit(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                Serenity.EditorUtils.setReadonly(this.form.ItemDetails.element, false);
                this.form.ItemDetails.canUpdate = 1;
                if (!self.isEditMode())
                    return;
                self.editClicked = true;
                self.updateInterface();
                self.form.ItemDetails.isReadOnly = false; 
                self.updateTitle();
            }
        }

        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {

                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        StockAllocationService.Delete(
                            {
                                EntityId: this.entityId
                            }, response => {
                                Serenity.SubDialogHelper.triggerDataChange(self);
                                self.dialogClose();
                                window.setTimeout(() => //Q.notifySuccess(Q.text('Deleted successfully')), 0);
                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Deleted!',
                                        text: 'Voucher Deleted',
                                        showConfirmButton: false,
                                        timer: 1500
                                    })
                                );
                            }
                        );
                    }
                })
            }
        } 
        protected validateBeforeSave() {
            super.validateBeforeSave();
            var items = this.form.ItemDetails.getItems();
            for (var i = 0; i < items.length; i++) {
                if (items[i].Pieces < items[i].AllocatedPieces || items[i].Weight < items[i].AllocatedWeight) {
                    q.alert('Invalid values', 'Allocated Values cannot be greater than required for ' + items[i].ProductCode, true, 2999);
                    return false;
                }
            }
            return true;
        }
    }
}